import { css } from '@emotion/css';
import { palette } from 'Shared/backend/theme';
import { createSignal, JSX } from 'solid-js';
import { For } from 'solid-js';
import { Dynamic } from 'solid-js/web';


const tabsStyle = () => css({ 
	whiteSpace: 'noWrap'
});

const tabStyle = () => css({
	fontSize: 16,
	color: palette.dimText,
	border: '1px solid #eee',
	padding: '0.6em',
	display: 'inline-block',
	cursor: 'pointer',
	userSelect: 'none'
});

const activeTabStyle = () => css(tabStyle(),{
	borderBottom: `1px solid ${palette.background}`,
	color: palette.darkText
});

const nestedTabStyle = () => css(tabStyle(),{
	display: 'inline-block',
	border: `1px solid ${palette.dimBackground}`
});

const nestedActiveTabStyle = () => css(tabStyle(),{
	background: palette.dimBackground,
	color: palette.darkText
});


export interface ITabs {
	tabs: {[name:string]: JSX.Element};
	initial: string;
	nested?: boolean;
}


export function TabPanes(props:ITabs)
{		
	const [current,setCurrent] = createSignal(props.initial);

	return (<>
		<TabBar  {...props} tabs={props.tabs} current={current} setCurrent={setCurrent} />
		<TabPane {...props} tabs={props.tabs} current={current} setCurrent={setCurrent} />
	</>);
}

export function TabBar(props)
{		
	const style = key => props.nested ?
		(key==props.current() ? nestedActiveTabStyle() : nestedTabStyle())
		:
		(key==props.current() ? activeTabStyle() : tabStyle());

	return (
		<div class={tabsStyle()}>
			<For each={Object.keys(props.tabs)}>{(key) => 
				<div class={style(key)} onClick={() => props.setCurrent(key)}>
					{key}
				</div>
			}</For>
		</div>
	);
}

export function TabPane(props)
{		
	return <Dynamic component={props.tabs[props.current()]} {...props} />;
}

